import {Component, OnInit} from '@angular/core';
import {LoaderService} from 'src/app/services/loader.service';

@Component({
  selector: 'app-unauthorized-access',
  templateUrl: './unauthorized-access.component.html',
  styleUrls: ['./unauthorized-access.component.sass']
})
export class UnauthorizedAccessComponent implements OnInit {

  constructor(
    private loaderService: LoaderService
  ) {
  }

  ngOnInit(): void {
    this.loaderService.toggleLoader(false);
  }

}
